export interface IContentProps {
    searchPlaceholderText: string;
    searchButtonText: string;
    searchSuggestionText: string;
    filtersSectionHeader: string;
    resetButtonText: string;
    preSearchMessage: string;
    noResultsMessage: string;
    contextItems: string[];
    contextPlaceholderText: string;
    sortsLabel: string;
    relevanceSortText: string;
    dateSortText: string;
    reverseDateSortText: string;
    alphabeticalSortText: string;
    reverseAlphabeticalSortText: string;
    allowSortByAlphabet: boolean;
    dateSortRelevanceFilter: number;
    generalErrorText: string;
    loadingResultsText: string;
    zeroResultsText: string;
    numberOfResultsText: string;
    pageSize: number;
    nasbaCreditText: string;
    creditText: string;
}

export const DefaultContentProps = {
    searchPlaceholderText: '',
    searchButtonText: '',
    searchSuggestionText: '',
    filtersSectionHeader: '',
    resetButtonText: '',
    preSearchMessage: '',
    noResultsMessage: '',
    contextItems: [],
    contextPlaceholderText: '',
    sortsLabel: '',
    relevanceSortText: '',
    dateSortText: '',
    reverseDateSortText: '',
    alphabeticalSortText: '',
    reverseAlphabeticalSortText: '',
    allowSortByAlphabet: false,
    dateSortRelevanceFilter: '',
    generalErrorText: '',
    loadingResultsText: '',
    zeroResultsText: '',
    numberOfResultsText: '',
    pageSize: 10,
    nasbaCreditText: '',
    creditText: ''
}